import React, { useState, useEffect } from 'react'
import CampaignHeader from './campaign-header'
import Leads from './campaign-pages/leads'
import Generate from './campaign-pages/generate'
import Analytics from './campaign-pages/analytics'
import Template from './campaign-pages/template'
import { Switch, Route, useParams, useRouteMatch } from 'react-router-dom';
import { apiUrl, pageUrl, protocol } from "../../utils/url";
import { hideLoader, showLoader } from '../loader'
import NewSideBar from '../side-bar/new-sidebar'
import { useDispatch, useSelector } from 'react-redux'
import GrapeJs from '../../pages/grapeJs/grapejs'
import EditProduct from './edit-product'

const EditCampaign = () => {
    let { path } = useRouteMatch();
    let { id, campaign_id, tab } = useParams();
    const dispatch = useDispatch();
    const [iframeURL, setIframeURL] = useState(1);
    const [iframeIndex, setIframeIndex] = useState(1);
    const [productData, setProductData] = useState({});
    const [productSlug, setProductSlug] = useState();
    const [activeBlock, setActiveBlock] = useState({ name: "template_settings", id: null, data: {} });
    // const { slug } = useSelector(state => state?.slugReducer);

    const editProduct = (product_id) => {
        const api = apiUrl + "/ProductFlow/edit/" + product_id;
        showLoader()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "GET",
            headers: myHeaders,
        }
        fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    setProductData(response?.data)
                    dispatch({ type: 'SET_CAMPAIGN_DETAILS', payload: response.data });
                    setProductSlug(response?.data?.slug)
                    dispatch({ type: 'SET_PRODUCT_BLOCKS', payload: response?.data?.product_blocks });
                    setIframeURL(protocol + '' + id + '.' + pageUrl + '/' + (response?.data?.slug) + '?iframe=1');
                    setIframeIndex(iframeIndex + 1);
                }
                hideLoader();
            }).catch(() => {
                hideLoader();
            });
    }

    useEffect(() => {
        if (campaign_id) {
            editProduct(campaign_id);
        }
        dispatch({ type: "SET_SLUG", payload: { slug: id, basePath: "/project/" + id, newChange: false } })
    }, []);
    const commonProps = {
        productData,
        iframeURL,
        iframeIndex,
        productSlug,
        setIframeURL,
        setIframeIndex,
        setProductData,
        setProductSlug,
        campaign_id,
        editProduct,
        productSlug,
        activeBlock,
        setActiveBlock
    };
    return (
        <div id="wrapper">
            <CampaignHeader setActiveBlock={setActiveBlock} productData={productData} editProduct={editProduct} />
            <Switch>
                {productData?.id &&(
                    productData?.page_builder ?
                        <Route
                            exact
                            path={`${path}/template`}
                            render={(props) => <GrapeJs {...props} {...commonProps} />}
                        />:
                        <Route
                            exact
                            path={`${path}/template`}
                            render={(props) => <EditProduct {...props} {...commonProps} />}
                        />
                    )}
            </Switch>
            <div className='community-main'>
                <NewSideBar from="campaign_leads" />
                <Switch>
                    <Route
                        exact
                        path={`${path}/leads`}
                        render={(props) => <Leads {...props} {...commonProps} />}
                    />
                    <Route
                        exact
                        path={`${path}/generate`}
                        render={(props) => <Generate {...props} {...commonProps} />}
                    />
                    <Route
                        exact
                        path={`${path}/analytics`}
                        render={(props) => <Analytics {...props} {...commonProps} />}
                    />
                </Switch>
            </div>
        </div>
    )
}

export default EditCampaign